'use client';

import AiSuggestionChip from '@carvana/ds-ai-suggestion-chip';
import { useCallback, useRef } from 'react';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import useComposerStarterQuestionTypewriter from '~/hooks/home/useComposerStarterQuestionTypewriter';

type OwnProps = {
  disabled?: boolean;
  onSelectAction: (question: string) => void;
  questions: ReadonlyArray<string>;
};

export default function HomeStarterQuestion({
  disabled = false,
  onSelectAction,
  questions
}: OwnProps) {
  const { displayedText, targetQuestion } =
    useComposerStarterQuestionTypewriter(questions, !disabled);
  const pinnedQuestionRef = useRef<string | null>(null);
  const trackEvent = useTrackEvent();

  const handlePointerDown = useCallback(() => {
    pinnedQuestionRef.current = targetQuestion;
  }, [targetQuestion]);

  const handleClick = useCallback(() => {
    const question = pinnedQuestionRef.current ?? targetQuestion;
    pinnedQuestionRef.current = null;

    trackEvent('composer_shell_questions_click', {
      action: 'clicked',
      question
    });

    onSelectAction(question);
  }, [onSelectAction, targetQuestion, trackEvent]);

  return (
    <div
      className="flex shrink-0 items-center gap-sm"
      data-testid="home-starter-question"
    >
      <span className="text-text-strong t-label-sm">Get started</span>
      <AiSuggestionChip
        aria-busy={disabled}
        aria-label={targetQuestion}
        data-analytics-id={null}
        data-testid="home-starter-question-chip"
        disabled={disabled}
        iconLeft={false}
        label={displayedText}
        onClick={handleClick}
        onPointerDown={handlePointerDown}
        testId="home-starter-question-chip"
      />
    </div>
  );
}
